import React from 'react';
import { motion } from 'framer-motion';
import { Search, Calculator, Scale, Ship, Wrench, Truck } from 'lucide-react';
const steps = [{
  id: 1,
  title: 'Inspección y Análisis del Vehículo',
  description: 'Analizamos daños, condición mecánica y potencial de mercado antes de comprar — para que tu decisión sea informada y tu capital esté protegido desde el primer momento.',
  icon: Search,
  status: 'Paso 1',
  color: 'text-earia-accent-hover',
  bg: 'bg-earia-accent/10',
  border: 'border-earia-accent/20',
  badgeColor: 'bg-earia-accent text-earia-text-heading'
}, {
  id: 2,
  title: 'Cálculo Transparente de Costos',
  description: 'Desglose con precisión precio de subasta, impuestos (DAI, IVA), primera matrícula, costo estimado de piezas y reparación — sin sorpresas, para que cada dólar invertido sea una decisión financiera inteligente.',
  icon: Calculator,
  status: 'Paso 2',
  color: 'text-earia-accent-hover',
  bg: 'bg-earia-accent/10',
  border: 'border-earia-accent/20',
  badgeColor: 'bg-earia-accent text-earia-text-heading'
}, {
  id: 3,
  title: 'Asesoría Legal y Verificación',
  description: 'Verificamos títulos (Clean, Salvage, Rebuildable) y gestionamos trámites de circulación: emisión de gases, experticia y placas — protegiendo tu inversión con respaldo legal completo.',
  icon: Scale,
  status: 'Paso 3',
  color: 'text-earia-accent-hover',
  bg: 'bg-earia-accent/10',
  border: 'border-earia-accent/20',
  badgeColor: 'bg-earia-accent text-earia-text-heading'
}, {
  id: 4,
  title: 'Logística y Transporte',
  description: 'Coordinamos transporte terrestre en USA y flete marítimo seguro hasta Acajutla — maximizando el valor de tu inversión en cada etapa del trayecto.',
  icon: Ship,
  status: 'Paso 4',
  color: 'text-blue-600',
  bg: 'bg-blue-100',
  border: 'border-blue-200',
  badgeColor: 'bg-blue-500 text-white'
}, {
  id: 5,
  title: 'Piezas y Reparación',
  description: '¿Problemas para encontrar piezas? Te ayudamos a localizarlas y adquirirlas de forma rápida y segura, para que tu vehículo quede en óptimas condiciones sin gastar de más.',
  icon: Wrench,
  status: 'Paso 5',
  color: 'text-blue-600',
  bg: 'bg-blue-100',
  border: 'border-blue-200',
  badgeColor: 'bg-blue-500 text-white'
}, {
  id: 6,
  title: 'Entrega a Tu Puerta',
  description: 'Gestionamos la entrega desde la almacenadora hasta donde lo necesites.',
  icon: Truck,
  status: 'Entregado',
  color: 'text-earia-success',
  bg: 'bg-earia-success/10',
  border: 'border-earia-success/20',
  badgeColor: 'bg-earia-success text-white'
}];
export function ProcessSection() {
  return <section id="process" className="py-20 bg-earia-bg" data-id="element-378">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-379">
        <div className="text-center mb-16" data-id="element-380">
          <h2 className="text-3xl md:text-4xl font-bold text-earia-text-heading mb-4" data-id="element-381">
            Tu importación, paso a paso
          </h2>
          <p className="text-earia-text-body max-w-2xl mx-auto text-lg" data-id="element-382">
            Un proceso diseñado para transformar tu compra en una decisión
            financiera inteligente que fortalezca tu patrimonio.
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto" data-id="element-383">
          {/* Connecting Line (Desktop) */}
          <div className="absolute left-8 top-8 bottom-8 w-0.5 bg-earia-border hidden md:block" data-id="element-384"></div>

          <div className="space-y-12" data-id="element-385">
            {steps.map((step, index) => <motion.div key={step.id} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="relative flex flex-col md:flex-row gap-6 md:gap-10 items-start" data-id="element-386">
                {/* Icon Circle */}
                <div className={`flex-shrink-0 w-16 h-16 rounded-full ${step.bg} ${step.border} border flex items-center justify-center z-10 bg-earia-card shadow-sm`} data-id="element-387">
                  <step.icon className={`w-8 h-8 ${step.color}`} data-id="element-388" />
                </div>

                {/* Content Card */}
                <div className="flex-1 bg-earia-card border border-earia-border rounded-xl p-6 hover:shadow-md transition-all w-full" data-id="element-389">
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-4 gap-4" data-id="element-390">
                    <h3 className="text-xl font-bold text-earia-text-heading" data-id="element-391">
                      {step.title}
                    </h3>
                    <span className={`px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide w-fit ${step.badgeColor}`} data-id="element-392">
                      {step.status}
                    </span>
                  </div>
                  <p className="text-earia-text-body leading-relaxed" data-id="element-393">
                    {step.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}